import React, { useState, useEffect } from 'react';

// Particle/confetti component for celebrations
const StreakCelebration = ({ milestone, onComplete }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const colors = milestone >= 100
      ? ['#D8F250', '#FF5340', '#35C5F0', '#F5B72E', '#8B5CF6']
      : milestone >= 50
        ? ['#D8F250', '#35C5F0', '#F5B72E', '#8B5CF6']
        : ['#D8F250', '#35C5F0', '#FF5340'];

    const particleCount = milestone >= 100 ? 60 : milestone >= 50 ? 40 : 25;

    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      x: 50 + (Math.random() - 0.5) * 20,
      y: 50,
      vx: (Math.random() - 0.5) * 15,
      vy: -Math.random() * 12 - 5,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: Math.random() * 8 + 4,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 20,
    }));

    setParticles(newParticles);

    const timer = setTimeout(() => {
      onComplete();
    }, 2000);

    return () => clearTimeout(timer);
  }, [milestone, onComplete]);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      pointerEvents: 'none',
      zIndex: 1000,
      overflow: 'hidden',
    }}>
      {/* Milestone banner */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: 'streakPop 0.5s ease-out forwards',
      }}>
        <div style={{
          background: milestone >= 100
            ? 'var(--pro)'
            : milestone >= 50
              ? 'var(--cyan)'
              : 'var(--lime)',
          padding: '20px 48px',
          border: 'var(--border)',
          borderRadius: 'var(--r-lg)',
          boxShadow: 'var(--sh-lg)',
          textAlign: 'center',
        }}>
          <div style={{ marginBottom: '6px', display: 'flex', justifyContent: 'center' }}>
            {milestone >= 100 ? (
              /* trophy */
              <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="var(--lime-ink)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M7 4h10v6a5 5 0 0 1-10 0V4Z" /><path d="M7 6H4v1a3 3 0 0 0 3 3" /><path d="M17 6h3v1a3 3 0 0 1-3 3" /><path d="M12 15v3" /><path d="M9 21h6" /><path d="M10 18h4l1 3H9l1-3Z" />
              </svg>
            ) : milestone >= 50 ? (
              /* flame */
              <svg width="46" height="46" viewBox="0 0 24 24" fill="var(--lime-ink)" aria-hidden="true">
                <path d="M12 2s5.5 5 5.5 10a5.5 5.5 0 0 1-11 0c0-1.5.5-2.8 1.2-4 .3 1.7 1.6 3 3.1 3 0-3.4 1.2-6.6 1.2-9Z" />
              </svg>
            ) : (
              /* bolt */
              <svg width="46" height="46" viewBox="0 0 24 24" fill="var(--lime-ink)" aria-hidden="true">
                <path d="M13.5 2 4 14h6l-.5 8L19 10h-6l.5-8Z" />
              </svg>
            )}
          </div>
          <div style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: 'var(--lime-ink)',
            fontFamily: 'var(--display)',
          }}>
            {milestone} 连胜!
          </div>
          <div style={{
            fontSize: '14px',
            color: 'var(--lime-ink)', opacity: 0.75,
            marginTop: '4px',
          }}>
            {milestone >= 100 ? '传奇成就!' : milestone >= 50 ? '太厉害了!' : '继续加油!'}
          </div>
        </div>
      </div>

      {/* Particles */}
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            borderRadius: p.size > 6 ? '2px' : '50%',
            animation: `particleFall 1.5s ease-out forwards`,
            transform: `rotate(${p.rotation}deg)`,
            '--vx': p.vx,
            '--vy': p.vy,
            '--rot': p.rotationSpeed,
          }}
        />
      ))}

      <style>{`
        @keyframes streakPop {
          0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
          50% { transform: translate(-50%, -50%) scale(1.1); }
          100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
        }
        @keyframes particleFall {
          0% {
            transform: translate(0, 0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translate(calc(var(--vx) * 20px), calc(var(--vy) * -30px + 300px)) rotate(calc(var(--rot) * 20deg));
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default StreakCelebration;
